import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/")({
  head: () => pageHead("Admin \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  beforeLoad: () => {
    throw redirect({ to: "/admin/orders" });
  },
});
